import angular from 'angular';

import componentNameForFieldType from '../simpleFields';
import {cacheBustImages, convertPlainTextStringToBasicMarkup} from '../../../../../lib/util';

class SimpleFieldInstanceController {
  constructor(
    $scope,
    $log,
    $q,
    $element,
    $compile,
    $sce,
    DEBUG,
    $translate,
    APIService,
    LanguageService
  ) {
    "ngInject";
    this.$scope = $scope;
    this.$log = $log;
    this.$q = $q;
    this.$element = $element;
    this.$compile = $compile;
    this.$sce = $sce;
    this.DEBUG = DEBUG;
    this.$translate = $translate;
    this.APIService = APIService;
    this.LanguageService = LanguageService;
    this._translations = {};
  }

  $postLink() {
    return this._addFieldComponent();
  }

  $onInit() {
    const promises = [];

    promises.push(
      this._getTranslations(this.translationKeys)
        .then(translations => this._translations = translations)
    );
    return this.$q.all(promises);
  }

  get field() {
    return this._field;
  }
  set field(field) {
    this._field = field;
  }

  get fieldType() {
    return this.field.field_type_constant;
  }

  get validations() {
    return this.fieldInstance.validations;
  }

  get fieldHasInput() {
    return !this.field.isSubsectionField;
  }

  get hasError() {
    return this.field.errors && this.field.errors.length > 0;
  }

  get formattedDisplayText() {
    let text = this.field && this.LanguageService.translateProperty(this.field, 'name') || '';

    return text ? String(text).replace(/<[^>]+>/gm, '') : '';
  }

  get displayImageURL() {
    // TODO: Convert relative URL to absolute
    if (this.field && this.field.isDisplayImageField && this.field.image) {
      setTimeout(() => {
        cacheBustImages()
      }, 200)
      return this.field.image;
    } else {
      return '';
    }
  }

  get displayImageAltText() {
    return this.field.name;
  }

  get downloadDocumentTemplateURL() {
    let documentUrl = null;
    if (this.field.documents_id) {
      documentUrl = this.APIService.convertPathToURL(`/docs/${this.field.documents_id}`);
    }
    return documentUrl;
  }

  get downloadDocumentURL() {
    let documentUrl = null;
    if (this.field.value) {
      documentUrl = this.APIService.convertPathToURL(`/docs/${this.field.value}`);
    }
    return documentUrl;
  }

  get minMaxLengthText() {
    let text = '';
    if (this.field.min_length) {
      let s = 'Min: ' + this.field.min_length + ' ' + (this.translations['CHARACTERS'] || 'characters').toLowerCase() + ' ';
      text += s;
    }
    if (this.field.min_length && this.field.max_length) text += ' / ';
    if (this.field.max_length) {
      let s = 'Max: ' + this.field.max_length + ' ' + (this.translations['CHARACTERS'] || 'characters').toLowerCase();
      text += s;
    }

    return text;
  }

  _addFieldComponent() {
    const newScope = this.$scope.$new(true, this.$scope);
    newScope.field = this.field;
    newScope.inputId = this.inputId;

    const passVars = {
      'field': 'field',
    };
    const passHtml = Object.keys(passVars)
      .map(key => key + '="' + passVars[key] + '"')
      .join(' ');

    const fieldComponentName = componentNameForFieldType(this.fieldType);
    if (!fieldComponentName) {
      this.$log.error("Unable to find component for field type", this.fieldType);
      return;
    }

    const elementName = fieldComponentName.replace(/([A-Z])/g, '-$1').toLowerCase();
    const html = '<' + elementName + ' ' + passHtml + '></' + elementName + '>';
    const compiled = this.$compile(html)(newScope);
    this.$log.info("HTML:", html, "compiled:", compiled);
    this.$log.info(this.field);
    const result = this._getFieldWrapperElement().append(html);
    this.$compile(result)(newScope);
  }

  _getFieldWrapperElement() {
    const el = this.$element[0].querySelector('.fieldinstance-field');
    return angular.element(el);
  }

  get translations() {
    return this._translations;
  }

  get translationKeys() {
    return [
      'REQUIRED',
    ];
  }

  _getTranslations(translationKeys) {
    return this.$q
      .all(
        translationKeys.map(key => {
          const promise = this.$translate(key);
          return promise.then(translated => {
            return {key, translated};
          });
        })
      )
      .then(translationInfo => translationInfo.reduce((o, info) => {
        o[info.key] = info.translated;
        return o;
      }, {}))
      .catch(err => {
        this.$log.error("Error loading translations:", err);
        return this.$q.reject(err);
      });
  }
}

export default SimpleFieldInstanceController;
